import React from 'react'
import './DeprecatedTemplateIndicator.scss'

export interface DeprecatedTemplateIndicatorProps {
  variant: 'dot' | 'icon-dot'
  title?: string
}

export const DeprecatedTemplateIndicator: React.FC<DeprecatedTemplateIndicatorProps> = ({ variant, title }) => (
  <span className={variant === 'icon-dot' ? 'deprecated-template-icon-dot' : 'deprecated-template-dot'} title={title} />
)
